// Helpers locales simples
const getSafeInt = (val) => {
    // Si el valor es estrictamente 0 o el string "0", devolvemos 0 numérico
    if (val === 0 || val === "0") return 0;
    // Si el valor es nulo, indefinido o vacío, devolvemos 0 por defecto
    if (val === undefined || val === null || val === "") return 0;
    
    const cleanVal = String(val).replace(/\D/g, ''); 
    return cleanVal.length > 0 ? parseInt(cleanVal, 10) : 0;
};

// Busca el valor de una columna ignorando mayúsculas, minúsculas y espacios.
const getValue = (row, possibleNames) => {
    const names = Array.isArray(possibleNames) ? possibleNames : [possibleNames];
    const rowKeys = Object.keys(row);
    
    for (const name of names) {
        const normalizedToFind = name.toLowerCase().trim();
        const foundKey = rowKeys.find(k => k.toLowerCase().trim() === normalizedToFind);
        if (foundKey !== undefined) return row[foundKey];
    }
    return undefined;
};

/**
 * GenericStrategy - Lógica de importación estándar.
 * Implementa búsqueda en memoria por Endoso y Cuota.
 */
export const GenericStrategy = {
    name: "GENERICO",

    /**
     * cleanSearchValue: Estandariza el nPoliza como String y quita el .0 de Excel.
     */
    cleanSearchValue: (rawVal) => {
        if (rawVal === 0 || rawVal === "0") return "0";
        if (rawVal === undefined || rawVal === null || rawVal === "") return '';
        
        let s = String(rawVal).trim();
        if (s.endsWith('.0')) s = s.replace('.0', '');
        return s;
    },

    /**
     * findExistingRecord: BUSQUEDA PROFESIONAL EN MEMORIA.
     * Machea contra datos existentes usando Endoso y Cuota.
     * Esto permite reconocer registros viejos sin necesidad de campos nuevos en la DB.
     */
    findExistingRecord: (row, existingRecords) => {
        if (!existingRecords || existingRecords.length === 0) return null;

        // Extraemos valores del Excel actual
        const endosoExcel = getSafeInt(getValue(row, ['Endoso', 'nEndoso', 'Nro Endoso', 'Endo']));
        const cuotaExcel = getSafeInt(getValue(row, ['Cuota', 'nCuota', 'Nro Cuota']));

        // Buscamos en el listado de la DB que nos pasó el orquestador
        return existingRecords.find(rec => 
            getSafeInt(rec.endoso) === endosoExcel && 
            getSafeInt(rec.cuota) === cuotaExcel
        ) || null;
    },

    processRow: (row, existingRecord) => {
        // 1. Extracción de campos básicos
        const nPolizaRaw = getValue(row, ['nPoliza', 'Poliza', 'Nro Poliza']);
        const nPoliza = GenericStrategy.cleanSearchValue(nPolizaRaw);
        
        const endoso = getSafeInt(getValue(row, ['Endoso', 'nEndoso', 'Nro Endoso', 'Endo']));
        const cuota = getSafeInt(getValue(row, ['Cuota', 'nCuota', 'Nro Cuota']));

        // 2. Limpieza de Importe
        let importeExcel = 0;
        const rawImporte = getValue(row, ['Importe', 'Monto', 'Total', 'Valor']);
        if (rawImporte !== undefined && rawImporte !== null && rawImporte !== '') {
            if (typeof rawImporte === 'number') {
                importeExcel = rawImporte;
            } else {
                const cleanValue = String(rawImporte)
                    .replace(/\$/g, '').replace(/\s/g, '').replace(/\./g, '').replace(',', '.');
                importeExcel = parseFloat(cleanValue);
            }
        }

        const moneda = getValue(row, ['Moneda', 'Divisa']) || '$';
        const formaPagoExcel = getValue(row, ['FormaPago', 'Forma de Pago', 'Medio']) || 'TARJETA';
        const motivoExcel = getValue(row, ['Motivo', 'Desc. Motivo', 'Estado']) || '';

        // 3. Lógica de Intentos (Idempotencia)
        const excelIntento = getSafeInt(getValue(row, ['IntentoCobro', 'Intento']));
        const intentoFinal = excelIntento > 0 
            ? excelIntento 
            : (existingRecord ? (getSafeInt(existingRecord.intentoCobro) + 1) : 1);

        let estadoGestion = '';
        let estadoDeuda = '';
        let motivoDeuda = motivoExcel;

        if (existingRecord && getSafeInt(existingRecord.intentoCobro) === intentoFinal) {
            estadoGestion = existingRecord.estado || 'Pendiente';
            estadoDeuda = existingRecord.estadoDeuda || 'Rechazo';
            if (!motivoDeuda) motivoDeuda = existingRecord.motivoDeuda;
        } else {
            // Lógica genérica de estados
            estadoGestion = intentoFinal === 1 ? 'Sin Asignar' : 'Pendiente';
            estadoDeuda = 'Rechazo';
        }

        return {
            action: 'SAVE',
            data: {
                nPoliza: String(nPoliza),
                endoso: endoso,
                cuota: cuota,
                intentoCobro: intentoFinal,
                motivoDeuda: motivoDeuda,
                importe: importeExcel,
                moneda: moneda,
                estadoDeuda: estadoDeuda,
                estado: estadoGestion,
                formaPago: formaPagoExcel,
                ultimaImportacion: new Date().toISOString(),
            }
        };
    }
};